






























import { Component, Vue } from 'vue-property-decorator';
import { LoginCredentials } from '../interfaces/loginCredentials';
import { Action } from 'vuex-class';
import AppMessage from 'modules/core/models/appMessage';
import { ApiResponse } from '../interfaces/apiResponse';
import { ElForm } from 'element-ui/types/form';

@Component
export default class SetNewPassword extends Vue {
  public form: any = {
    Password: '',
    ConfirmPassword: '',
  };
  public validationRules!: any;
  public loading: boolean = false;

  @Action('auth/setNewPassword') private setNewPassword!: (
    email: string,
  ) => Promise<boolean | undefined>;

  public created() {
    this.validationRules = {
      Password: [
        {
          trigger: 'blur',
          validator: (rule: any, value: string, callback: (error?: Error) => void) => {
            const strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})');
            if (strongRegex.test(value)) {
              callback();
            } else {
              callback(new Error(this.$t('forms.passwordPolicy') as string));
            }
          },
        },
      ],
      ConfirmPassword: [
        {
          trigger: 'blur',
          validator: (rule: any, value: string, callback: (error?: Error) => void) => {
            if (value !== '' && value === this.form.Password) {
              callback();
            } else {
              callback(new Error(this.$t('forms.passwordsNotMatch') as string));
            }
          },
        },
      ],
    };
  }

  public onSubmit() {
    try {
      this.loading = true;

      (this.$refs.setNewPasswordForm as ElForm).validate(async (valid: boolean) => {
        if (valid) {
          try {
            const success = await this.setNewPassword({
              ...this.form,
              PasswordResetToken: this.$route.params.token,
              UserId: this.$route.params.userId,
            });
            if (success) {
              AppMessage.show(
                this.$t('setNewPassword.success'),
                'success',
              );
              this.$router.push('/login');
            } else {
              AppMessage.show(
                this.$t('setNewPassword.failure'),
                'error',
              );
              this.loading = false;
            }
          } catch (error) {
            console.warn('error', error);
            AppMessage.show(
              this.$t('setNewPassword.failure'),
              'error',
            );
            this.loading = false;
          }
        } else {
          this.loading = false;
          return false;
        }
      });
    } catch (error) {
      this.loading = false;
      console.warn('Error during registration process: ' + error);
      AppMessage.show(
        this.$t('setNewPassword.failureMsg', { msg: error }),
        'error',
      );
    }
  }
}
